export enum CustomerReview {
    DIDNT_LIKE = "1",
    GOOD_BUT_SEEN_BETTER = "2",
    PERFECT = "3",
    TOO_LONG = "4",
    TOO_SHORT = "5",
}
